/*
|--------------------------------------------------------------------------
| Data: Prep
|--------------------------------------------------------------------------
*/
/**
 * Prepare data. Pass an array of functions that can be run over a data set
 *
 * @namespace
 * @param {object} options
 * @param {array} options.controllers - array of function paths
 * @param {array} options.data - data set
 * @example
 * __gh__webApp.data.prep({controllers:["__gh__webApp.data.sortBy.date"],[{"isodate":"2014-10-08","title":"Example"}])
 */
__gh__webApp.data.prep = function(options){
	var controllers 	= (options.controllers) ? options.controllers 	: [];
	var data 			= (options.data) 		? options.data 			: {};

	if(controllers.length > 0){
		for(ii=0;ii<controllers.length;ii++){
			var fn = __gh__webApp.common.stringToFunction(controllers[ii]);
			if (fn){
				fn(data);
			}
		}
	}
};
